// extracted by mini-css-extract-plugin
export default {"navbar":"Banner_navbar__ffYb4","logo":"Banner_logo__S-BJt","logoWidth":"Banner_logoWidth__Yk1OK","title":"Banner_title__v78Pq"};